import { connect } from 'react-redux';
import QueryToState from './query-to-state';
import {
  setDateRange,
  setComparisonDateRange,
  setFilterOption,
  setUseDefaultDateRange,
} from '../../reducers/filter.reducers';
import {
  selectLocationOnLoad,
  selectReportOnLoad,
  selectLocation,
  selectReport,
} from '../../reducers/reports.reducers';
import {
  setDebug,
  setInApp,
} from '../../reducers/app.reducers';

const mapStateToProps = state => ({
  locations: state.reports.locations,
  selectedLocation: state.reports.selectedLocation,
  selectedReport: state.reports.selectedReport,
  dateRange: state.filter.dateRange,
  comparisonDateRanges: state.filter.comparisonDateRanges,
  inApp: state.app.inApp,
});

const mapDispatchToProps = dispatch => ({
  selectLocationOnLoad: id => dispatch(selectLocationOnLoad(id)),
  selectReportOnLoad: id => dispatch(selectReportOnLoad(id)),
  selectLocation: id => dispatch(selectLocation(id)),
  selectReport: id => dispatch(selectReport(id)),
  setDateRange: dateRange => dispatch(setDateRange(dateRange)),
  setComparisonDateRange: startAndEndDate => dispatch(setComparisonDateRange(startAndEndDate)),
  setFilterOption: filterOption => dispatch(setFilterOption(filterOption)),
  setInApp: inApp => dispatch(setInApp(inApp)),
  setDebug: debug => dispatch(setDebug(debug)),
  setUseDefaultDateRange: useDefaultDateRange => dispatch(setUseDefaultDateRange(useDefaultDateRange)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QueryToState);
